import L from "leaflet";

export const orangeIcon = new L.Icon({
  iconUrl:
    "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-orange.png",
  shadowUrl:
    "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

export const parseCoordinates = str =>
  str.split(",").reduce((acc, curr) => {
    const [key, val] = curr.split("=");
    acc[key.trim()] = val.trim();
    return acc;
  }, {});
